import React from 'react';
import './App.scss';
import { Timeline } from './components/contents';

function App() {
	return (
		<Timeline />
	);
}

export default App;